<h2 mat-dialog-title data-testid="overlap-events-title">{{ events.length }} overlapping events</h2>

<mat-dialog-content data-testid="overlap-events-content">
  <div class="oe-list" role="list">
    @for (event of events; track event.key) {
      <button
        type="button"
        class="oe-row"
        role="listitem"
        matRipple
        (click)="select(event)"
        [attr.data-testid]="'overlap-event-' + event.id"
      >
        <span class="oe-title">{{ event.title }}</span>
        <span class="oe-time">
          {{ timeLabel(event.startHour, event.startMinute) }} –
          {{ timeLabel(event.endHour, event.endMinute) }}
        </span>
      </button>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()" data-testid="overlap-events-close-btn">Close</button>
</mat-dialog-actions>
